import { SVGProps } from 'react';

export const PageNotFound = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="141"
    height="141"
    viewBox="0 0 141 141"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle
      cx="70.5"
      cy="70.5"
      r="70.5"
      fill="currentColor"
      fillOpacity="0.03"
    />
    <circle cx="71" cy="71" r="61" fill="currentColor" fillOpacity="0.05" />
    <g transform="translate(38.3, 38)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M32.1844 0C27.3362 0 23.4067 3.93238 23.4067 8.77763H40.962C40.962 3.93238 37.0326 0 32.1844 0"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.5556 29.2578H5.85205C5.85205 32.488 8.47364 35.1096 11.7038 35.1096C14.934 35.1096 17.5556 32.488 17.5556 29.2578"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M32.1848 35.1096C35.4149 35.1096 38.0365 32.488 38.0365 29.2578H26.333C26.333 32.488 28.9546 35.1096 32.1848 35.1096"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M52.6662 35.1096C55.8964 35.1096 58.518 32.488 58.518 29.2578H46.8145C46.8145 32.488 49.436 35.1096 52.6662 35.1096"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M62.1544 16.999L40.9623 11.7031H23.407L2.21782 16.999C0.9158 17.3237 0 18.4941 0 19.8371V23.4066C0 25.0217 1.31079 26.3325 2.92588 26.3325H61.4434C63.0615 26.3325 64.3693 25.0217 64.3693 23.4066V19.8371C64.3693 18.4941 63.4564 17.3237 62.1544 16.999"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.7007 63.7313L20.412 65.0012L26.2638 38.6683L20.5524 37.3984L14.7007 63.7313Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M38.1079 38.6683L43.9597 65.0012L49.671 63.7313L43.8192 37.3984L38.1079 38.6683Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M29.2588 64.3679H35.1105V43.8867H29.2588V64.3679Z"
        fill="currentColor"
      />
    </g>
  </svg>
);
